import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_written_emergency_response_plan'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_written_emergency_response_plan',
  name: 'Does the facility have a written Emergency Response Plan?',
  description:
    'Refers to a written response plan for all buildings on-site, including all non-production buildings (e.g., childcare facilities, dormitories, canteen) as applicable.\r\r\n\r\r\nTo answer Yes, the plan must describe methods for \r\r\n1) reporting fires and other emergencies; AND\r\r\n2) alerting all workers to evacuate; AND\r\r\n3) evacuating workers to designated assembly location; AND\r\r\n4) accounting for all workers after an evacuation.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-18',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14570,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
